<template>
  <div class="warp-map">
      <baidu-map
        style="width: 100%;border-radius: 10px;"
        :style="{'height':height+'px'}"
        class="bm-view"
        :zoom="15"
        :center="center"
        inertial-dragging
        @ready="mapReady"
        @locationSuccess="success"
        :scroll-wheel-zoom="true"
        @click="getClickInfo"
      >
      <!-- <bm-panorama></bm-panorama> -->
        <!-- 定位控件   anchor="BMAP_ANCHOR_BOTTOM_RIGHT"代表放在右下角 -->
        <bm-geolocation
           v-if="isShow"
          anchor="BMAP_ANCHOR_BOTTOM_RIGHT"
          :showAddressBar="true"
          :autoLocation="true"
          @locationSuccess="success"
  
        ></bm-geolocation>

        <!-- <img src="../../../assets/custom-image/project/map_location.svg" alt=""> -->
        <!-- 地区检索  keyword：关键字搜索   @searchcomplete：检索完成后的回调函数   auto-viewport：检索结束后是否自动调整地图事业  -->
        <bm-local-search
          :keyword="keyword"
          :auto-viewport="true"
          class="search"
        ></bm-local-search>
        <!-- 缩放控件   anchor代表控件停靠位置   anchor="BMAP_ANCHOR_TOP_RIGHT"代表放在右上角
        <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation> -->
        <!-- <bm-control v-show="isShow" >
          <bm-auto-complete v-model="keyword" style="float: right;" :sugStyle="{zIndex: 1}"> -->

          <!-- </bm-auto-complete>
        </bm-control> -->
        <bm-local-search :keyword="keyword" :auto-viewport="true" ></bm-local-search>
        
        <!-- 添加点位 -->
          <bm-marker :position="center" :dragging="true" animation="BMAP_ANIMATION_BOUNCE">
          </bm-marker>
      </baidu-map>
      <div v-if="isShow" class="box">
        <el-autocomplete style="width:250px;border-radius: 10px;"  v-model="keyword" :fetch-suggestions="querySearch"  placeholder="请输入内容"  @select="handleSelect"></el-autocomplete>
        <div @click="search">
          <img src="@/assets/custom-image/project/map_search.svg" alt="">
        </div>
      </div>
  </div>
</template>

<script>
import {address} from '../../index'
//引入组件
import {
  BaiduMap,
  BmLocalSearch,
  BmGeolocation,
} from "vue-baidu-map";

export default {
  props:{
    isShow:{
      type:Boolean,
      default:true
    },
    isEdit:{
      type:Boolean,
      default:false
    },
    height:{
      type:Number,
      default:514
    },
  },
  data() {
    return {
      Bmap:'',
      //定位位置信息
      center: '北京',
      //检索关键字
      keyword: "",
      //输入框input值
      input3: "",
      //搜索带建议的输入框
      restaurants:[],
      seacth:[]
    };
  },
  watch:{
    keyword(newState,preState){
      if(newState == '')
        this.seacth = []
    }
  },
  //需要引入的组件
  components: {
    BaiduMap,
    BmLocalSearch,
    BmGeolocation,
  },
  created() {
    this.setAddress()
  },
  methods: {
    setAddress(){
      address[0].districts.forEach(item=>{
        let arr = [];
        item.districts.forEach(items=>{
          arr.push(items.citycode);
        })

        item.citycode = arr;
      })
    },
    search(){
      if(this.seacth.length == 0){
        this.$message.warning("未查找到指定地点")
        return;
      }
      let item = this.seacth[0];
      this.keyword = item.value;
      this.getClickInfo(item,true,item.value);
    },
    querySearch(queryString, cb) {
      var that = this
      var myGeo = new this.Bmap.Geocoder()
      myGeo.getPoint(queryString, function(point) {
        // if (point) {
        //   that.mapLocation.coordinate = point
        // } else {
        //   that.mapLocation.coordinate = null
        // }
      }, this.locationCity)
      var options = {
        onSearchComplete: function(results) {
          if (local.getStatus() === 0) {
            // 判断状态是否正确
            var s = []
            for (var i = 0; i < results.getCurrentNumPois(); i++) {
              var x = results.getPoi(i)
              console.log("results",results,"x1",x)
              let str = x.address == null || x.address == undefined?'':x.address;
              var item = { value:str + x.title, point: x.point }
              console.log("item",item)
              s.push(item)
              cb(s)
            }
            that.seacth = s;
          } else {
            cb()
          }
        }
      }
      var local = new this.Bmap.LocalSearch(this.map, options)
      local.search(queryString)
    },
    handleSelect(item) {
      console.log("选择",item)
      this.getClickInfo(item,true,item.value)
    },
    getClickInfo(obj,isClick=true,str=''){
      this.center = {
        lng:obj.point.lng,
        lat:obj.point.lat
      }
      
      console.log("obj",obj,'center',this.center)

      // }
      console.log("测试",this.center)
      // 通过经纬查询指定位置
      let geoc = new this.Bmap.Geocoder();
      geoc.getLocation(new this.Bmap.Point(this.center.lng,this.center.lat),res=>{
        console.log("测试address",res)
        // if(this.isShow){
          if(isClick){
            if(address[0].name == res.addressComponents.district){
              this.center.code = address[0].adcode;
            }else{
              console.log("resss",res.addressComponents.district);
              
              //this.getAddressCode(address[0],res.addressComponents.district);
              this.getCode(address[0],res.addressComponents);
            }
          }
          // setTimeout(() => {
          let arr = this.center;
          str = str ==''?res.address:str;  
          console.log("测试code", this.center)
          let s = this.bd_decrypt(obj.point.lng,obj.point.lat)
          console.log('测试',s)
          console.log('str----------------',str)
          var reg = /.+?(省|市|自治区|自治州|县|区)/g;
          let copy = str;
          let strArr = str.match(reg);
          str = str.substr(str.lastIndexOf(strArr[strArr.length-1])+strArr[strArr.length-1].length);
          // str.length == 0?str = copy:str;
          console.log('父类',this.$parent)
          try{
            this.$parent.setAddress(str,arr)
          }catch{
            this.$emit('setAddress',str,arr)
          }
          // },600)
         
        // }
      })
    },
    // 投入省市区的信息获取省市区三个code
    getCode(arr,address){
      // 获取省code
      for(let i = 0;i<arr.districts.length; i++){
        if(address.province == arr.districts[i].name){
          let city = arr.districts[i];
          this.center.code = [arr.districts[i].adcode,"",""]
          let district = ''
          for(let i = 0;i<city.districts.length; i++){
            let cityName = address.city == '北京市'?'北京城区':address.city;
            if(cityName == city.districts[i].name){
              district = city.districts[i];
              this.center.code[1] = city.districts[i].adcode
              for(let i = 0; i < district.districts.length; i++){
                if(address.district == district.districts[i].name){
                  this.center.code[2] = district.districts[i].adcode
                  break;
                }
              }
            }
          }
        }
      }

     

    
    },
    // 获取最后一级的code
    getAddressCode(arr,district){
      
      if(arr.districts == null || arr.districts == undefined || arr.districts.length == 0)return;

      for(let i =0; i < arr.districts.length; i++){
        let item = arr.districts[i];
        if(item.name == district){
              this.center.code = ["","",item.adcode];
              this.getAddressCode({},'');
              // new Promise(resolve=>{ resolve
                this.getCity(address[0],item.citycode)
              // }).then(value=>{
              //   resolveOne();
              // })
              
              return;
        }else{
          this.getAddressCode(item,district)
        }
      }
    },
    // 获取市级code
    getCity(arr,cityCode,resolveTwo){

      for(let i =0;i<arr.districts.length; i++){
        let item = arr.districts[i];
        for(let j = 0; j < item.districts.length; j++){
          let items = item.districts[j];
          if(items.citycode == cityCode){
            this.center.code[1] = items.adcode;
            
            // new Promise(resolve=>{ resolve
              this.getProvince(address[0],items.citycode)
            // }).then(value=>{
            //   resolveTwo();
            // })
            return;
          }
        }
      }
    },
    // 获得省级code
    getProvince(arr,proCode,resolveThree){

      for(let i = 0;i<arr.districts.length; i++){
        let item = arr.districts[i]

        if(Array.isArray(item.citycode)){
          for(let j = 0; j < item.citycode.length; j++){
            if(item.citycode[j] == proCode){
              this.center.code[0] = item.adcode;
              // resolveThree()
              return;
            }
          }
        }else{
          if(item.citycode == proCode){
            this.center.code[0] = item.adcode;
            // resolveThree()
            return;
          }
        }
      }
    },
    //输入框
    inputfz() {
      this.keyword = this.input3;
    },
    //地图加载后的回调
    mapReady({ BMap, map }) {
      if(BMap == undefined || BMap == null)return;
      console.log("地图加载")
      this.Bmap = BMap;
      this.map = map;
      //保存this指向，因为在百度的回调中this不指向vue
      const _this = this;
      // 获取自动定位方法

      if(!this.isShow || this.isEdit){
        console.log('关闭定位')
        return;
      };

      var geolocation = new this.Bmap.Geolocation();

      
      // 获取自动定位获取的坐标信息
      geolocation.getCurrentPosition(
        function (r) {
          //可以conso.log看一下这个r，他里面包含了检索到的位置信息。下面就把两个维度信息赋值给center来定位
          _this.center = {
            lng: r.point.lng,
            lat: r.point.lat,
          };
        },
        //启用高精度
        { enableHighAccuracy: true }
      );
    },
    success(obj){
        // console.log("获取指定位置",obj)
       // 通过经纬查询指定位置
       let geoc = new this.Bmap.Geocoder();
      geoc.getLocation(obj.point,res=>{
        if(this.isShow){
          this.$parent.setAddress(res.address)
        }
      })
    },
    //百度坐标转高德（传入经度、纬度）
    bd_decrypt(bd_lng, bd_lat) {
        var X_PI = Math.PI * 3000.0 / 180.0;
        var x = bd_lng - 0.0065;
        var y = bd_lat - 0.006;
        var z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * X_PI);
        var theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * X_PI);
        var gg_lng = z * Math.cos(theta);
        var gg_lat = z * Math.sin(theta);
        return {lng: gg_lng, lat: gg_lat}
    },
    //高德坐标转百度（传入经度、纬度）
    bd_encrypt(gg_lng, gg_lat) {
        var X_PI = Math.PI * 3000.0 / 180.0;
        var x = gg_lng, y = gg_lat;
        var z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * X_PI);
        var theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * X_PI);
        var bd_lng = z * Math.cos(theta) + 0.0065;
        var bd_lat = z * Math.sin(theta) + 0.006;
        return {
            bd_lat: bd_lat,
            bd_lng: bd_lng
        };
    }
},
mounted(){
    this.mapReady()
  }
}
</script>

<style scoped lang="scss">
//   :v-deep .el-input_inner{
//   position: relative;
//   right: -360px;
// }
::v-deep .search{
  height: 300px;
  overflow: auto;
  position: relative;
  z-index: -1;
  // top: 68px;
  // margin-top: 68px;
}
.warp-map{
   position: relative;
   border-radius: 10px;
   overflow: hidden;
}


.box{
  position: absolute;
  left:10px;
  display: flex;
  top:10px;
  input{
    background:none;outline:none;border:none;
    height: 36px;
    background: #FFFFFF;
    box-shadow: 0px 4px 5px 0px rgba(62,62,62,0.16);
    border-radius: 10px;
    border-style: none;
    color: #ABABAF;
    padding-left: 15px;
    &:hover{
      border-style: none;
    }
  }
  div{
    width: 50px;
    height: 36px;
    background: #087FFC;
    border-radius: 0px 10px 10px 0px;
    position: relative;
    
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
/* 给个宽高 */
.bm-view {
  height: 400px;
  width: 700px;
}
.input-with-select {
  width: 400px;
  margin-bottom: 5px;
}
.search {
  height: 300px;
  overflow: auto;
}
::v-deep .anchorBL{
  display: none;
}
</style>
